// src/utils/mediaUtils.js
export const parseVideoUrl = (url) => {
  if (!url) return null;

  // YouTube patterns
  const youtubePatterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
    /youtube\.com\/watch\?.*v=([^&\n?#]+)/
  ];
  
  for (const pattern of youtubePatterns) {
    const match = url.match(pattern);
    if (match) {
      return {
        platform: 'youtube',
        videoId: match[1],
        embedUrl: `https://www.youtube.com/embed/${match[1]}`,
        thumbnailUrl: `https://img.youtube.com/vi/${match[1]}/maxresdefault.jpg`,
        originalUrl: url
      };
    }
  }

  // Loom patterns
  const loomPattern = /loom\.com\/share\/([a-zA-Z0-9]+)/;
  const loomMatch = url.match(loomPattern);
  if (loomMatch) {
    return {
      platform: 'loom',
      videoId: loomMatch[1],
      embedUrl: `https://www.loom.com/embed/${loomMatch[1]}`,
      originalUrl: url
    };
  }

  // Vimeo patterns
  const vimeoPattern = /vimeo\.com\/(\d+)/;
  const vimeoMatch = url.match(vimeoPattern);
  if (vimeoMatch) {
    return {
      platform: 'vimeo',
      videoId: vimeoMatch[1],
      embedUrl: `https://player.vimeo.com/video/${vimeoMatch[1]}`,
      originalUrl: url
    };
  }

  // Google Drive patterns
  const drivePattern = /drive\.google\.com\/file\/d\/([^\/]+)/;
  const driveMatch = url.match(drivePattern);
  if (driveMatch) {
    return {
      platform: 'google-drive',
      videoId: driveMatch[1],
      embedUrl: `https://drive.google.com/file/d/${driveMatch[1]}/preview`,
      originalUrl: url
    };
  }

  // Dailymotion patterns
  const dailymotionPattern = /dailymotion\.com\/video\/([^_]+)/;
  const dailymotionMatch = url.match(dailymotionPattern);
  if (dailymotionMatch) {
    return {
      platform: 'dailymotion',
      videoId: dailymotionMatch[1],
      embedUrl: `https://www.dailymotion.com/embed/video/${dailymotionMatch[1]}`,
      originalUrl: url
    };
  }

  return null;
};

export const getPlatformIcon = (platform) => {
  const icons = {
    youtube: '▶️',
    loom: '🎥',
    vimeo: '🎬',
    'google-drive': '📁',
    dailymotion: '📺'
  };
  return icons[platform] || '🎬';
};